"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M12 8.546l1.217 2.254h-2.435L12 8.546z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.33 3C3.045 3 2 4.074 2 5.398v11.079c0 1.325 1.044 2.398 2.33 2.398H9.5l1.664 1.762a1.143 1.143 0 001.672 0l1.664-1.762h5.17c1.286 0 2.33-1.073 2.33-2.398V5.398C22 4.074 20.956 3 19.67 3H4.33zm8.544 2.927A.996.996 0 0012 5.398a.996.996 0 00-.875.53l-5 9.26a1.045 1.045 0 00.389 1.4.985.985 0 001.36-.4l1.797-3.33h4.657l1.797 3.33a.985.985 0 001.36.4c.483-.277.657-.903.389-1.4l-5-9.26z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;